var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.chipClasses},[_vm._v(" "+_vm._s(_vm.theme)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }